import React, { useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import TextInputMaskFormik from "../../../../components/UI/TextInput/TextInputMaskFormik";
import TextInputMoneyFormik from "../../../../components/UI/TextInput/TextInputMoneyFormik";
import useAcoesDemonstrativo from "../hooks/useAcoesDemonstrativo";
import TextInputFormik from "../../../../components/UI/TextInput/TextInputFormik";
import SelectTpCategoriaFormik from "../Components/SelectTpCategoriaFormik";
import SelectLivrosFiscaisFormik from "../Components/SelectLivrosFiscaisFormik";

const DemonstrativoD = ({ formik, sqAcaoFiscal, sqItemOcorrencia, dadosOcorrencia, tipoDetalhamento }) => {
  const { handleMoneyChange, calculaData } = useAcoesDemonstrativo({
    formik,
    sqAcaoFiscal,
  });

  const { setFieldValue } = formik;

  useEffect(() => {
    if (dadosOcorrencia) {
      setFieldValue("sqAcaoFiscal", sqAcaoFiscal);
      setFieldValue("sqItemOcorrencia", sqItemOcorrencia);
      setFieldValue("sqItem", dadosOcorrencia.sqItem);
      setFieldValue("txReferencia", dadosOcorrencia.txReferencia);
      setFieldValue("dtVencimento", dadosOcorrencia.dtVencimento);
      setFieldValue("tpCategoria", dadosOcorrencia.tpCategoria);
      setFieldValue("cdDocumento", dadosOcorrencia.cdDocumento);
      setFieldValue("qtItem", dadosOcorrencia.qtItem);
      setFieldValue("tipoDetalhamento", dadosOcorrencia.tipoDetalhamento);
    }
  }, [setFieldValue, dadosOcorrencia, sqAcaoFiscal, sqItemOcorrencia]);

  return (
    <>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Referência:</Form.Label>
          <TextInputMaskFormik
            formik={formik}
            field="txReferencia"
            placeholder="mm/aaaa"
            mask="99/9999"
            evento={calculaData}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Data de Vencimento:</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtVencimento" />
        </Form.Group>
      </Row>{" "}
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Categoria:</Form.Label>
          <br />
          <SelectTpCategoriaFormik formik={formik} field="tpCategoria" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Descrição:</Form.Label>
          <SelectLivrosFiscaisFormik formik={formik} field="cdDocumento" tipoItem="livro-fiscal-demonstrativo" />
        </Form.Group>
      </Row>
      <Row>
        {tipoDetalhamento !== "D" && (
          <Form.Group className="mb-3" as={Col} sm={12} md={4}>
            <Form.Label>ICMS a Recolher (R$):</Form.Label>
            <TextInputMoneyFormik
              formik={formik}
              field="vlIcms"
              type="number"
              prefix=" "
              onChange={handleMoneyChange}
            />
          </Form.Group>
        )}
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Quantidade:</Form.Label>
          <TextInputFormik formik={formik} field="qtItem" type="number" onlyPositive />
        </Form.Group>
      </Row>
    </>
  );
};

export default DemonstrativoD;
